export const authTokenHandler = {

    get: () => localStorage.getItem("token"),
    set: (v) => localStorage.setItem("token", v),
    clear: () => localStorage.removeItem("token"),
};

export const employeeNoHandler = {

    get: () => localStorage.getItem("employeeNo"),
    set: (v) => localStorage.setItem("employeeNo", v),
    clear: () => localStorage.removeItem("employeeNo"),
};

export const locationsHandler = {

    get: () => localStorage.getItem("locations"),
    set: (v) => localStorage.setItem("locations", v),
    clear: () => localStorage.removeItem("locations"),
};

export const locationNameHandler = {

    get: () => localStorage.getItem("locationName"),
    set: (v) => localStorage.setItem("locationName", v),
    clear: () => localStorage.removeItem("locationName"),
};

export const displayNameHandler = {

    get: () => localStorage.getItem("displayName"),
    set: (v) => localStorage.setItem("displayName", v),
    clear: () => localStorage.removeItem("displayName"),
};
export const userNameHandler = {

    get: () => localStorage.getItem("userName"),
    set: (v) => localStorage.setItem("userName", v),
    clear: () => localStorage.removeItem("userName"),
};
export const emailHandler = {

    get: () => localStorage.getItem("email"),
    set: (v) => localStorage.setItem("email", v),
    clear: () => localStorage.removeItem("email"),
};
export const roleHandler = {

    //get: () => {
    //    
    //    var x = localStorage.getItem("role");
    //    return x;
    //},
    get: () => localStorage.getItem("role"),
    set: (v) => localStorage.setItem("role", v),
    clear: () => localStorage.removeItem("role"),
};
export const locationHandler = {

    get: () => localStorage.getItem("location"),
    set: (v) => localStorage.setItem("location", v),
    clear: () => localStorage.removeItem("location"),
};

export const positionlHandler = {

    get: () => localStorage.getItem("position"),
    set: (v) => localStorage.setItem("position", v),
    clear: () => localStorage.removeItem("position"),
};

export const passwordExpireHandler = {

    get: () => localStorage.getItem("passwordExpire"),
    set: (v) => localStorage.setItem("passwordExpire", v),
    clear: () => localStorage.removeItem("passwordExpire"),
};

export const rolesHandler = {

    get: () => localStorage.getItem("roles"),
    set: (v) => localStorage.setItem("roles", v),
    clear: () => localStorage.removeItem("roles"),
};
export const permissionAccessHandler = {

    get: () => localStorage.getItem("permissionAccess"),
    set: (v) => localStorage.setItem("permissionAccess", v),
    clear: () => localStorage.removeItem("permissionAccess"),
};


export const pageAccessHandler = {
    get: () => localStorage.getItem("page-access"),
    set: (v) => localStorage.setItem("page-access", v),
    clear: () => localStorage.removeItem("page-access"),
};

export const pageMenuHandler = {
    get: () => localStorage.getItem("page-menu"),
    set: (v) => localStorage.setItem("page-menu", v),
    clear: () => localStorage.removeItem("page-menu"),
};

export const ngabHandler = {

    get: () => localStorage.getItem("ngab-token"),
    set: (v) => localStorage.setItem("ngab-token", v),
    clear: () => localStorage.removeItem("ngab-token"),
};

export const checkinLocationHandler = {

    get: () => localStorage.getItem("checkinLocation"),
    set: (v) => localStorage.setItem("checkinLocation", v),
    clear: () => localStorage.removeItem("checkinLocation"),
};

export const sessionHandler = {


    clear: () => {

        localStorage.removeItem("token");
        localStorage.removeItem("employeeNo");
        localStorage.removeItem("locations");
        localStorage.removeItem("displayName");
        localStorage.removeItem("userName");
        localStorage.removeItem("email");
        localStorage.removeItem("role");
        localStorage.removeItem("location");
        localStorage.removeItem("position");
        localStorage.removeItem("locationName");
        localStorage.removeItem("lastNotificationTime");
        localStorage.removeItem("durationShow");
        localStorage.removeItem("DoingToasty");
        localStorage.removeItem("passwordExpire");
        localStorage.removeItem("roles");
        localStorage.removeItem("page-access");
        localStorage.removeItem("page-menu");
        localStorage.removeItem("permissionAccess");
        localStorage.removeItem("checkinLocation");
        localStorage.removeItem("searchHistory");
    },
};